/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    white: '#FFFFFF',

    null: 'transparent',

    black: {
        10: '#F1F1F1',
        20: '#D4D4D4',
        30: '#B8B8B8',
        40: '#9C9C9C',
        50: '#808080',
        60: '#636363',
        70: '#474747',
        80: '#2A2A2A',
        90: '#0E0E0E',
        100: '#000000',
    },

    'brand-primary': {
        60: '#95BBEA',
        80: '#5589CC',
        100: '#266BBF',
    },

    'brand-secondary': {
        60: '#1A4B8A',
        80: '#143B6B',
        100: '#0C2340',
    },

    'brand-tertiary': {
        60: '#F0F7FE',
        80: '#DEEDFB',
        100: '#C9E3F9',
    },

    danger: {
        60: '#FEF2F3',
        80: '#FFA2AB',
        100: '#DE1C2F',
    },

    success: {
        60: '#EAFEE7',
        80: '#6BF462',
        100: '#0F8A0F',
    },

    borderLight: '#D4D4D4',
    overlayBackgroundModal: 'rgba(0, 0, 0, 0.75)',
    imageBackground: 'rgba(0,0,0,.05)',
}

export default colors
